import MWLogo from '../assets/MALWSP_logo_black.png';

export function AppLogo() {
    return <img src={MWLogo} alt="Mali Wspaniali" />;
}
